"use client";

import { useRouter } from "next/router";
import AddLink from "../components/form/addLink.comp";
import Layout from "../components/layouts/layout.comp";
import { ListSection } from "../components/reuseables/list.comp";
import TagListComp from "../components/tag/tagList.comp";
import { useTranslation } from "../core/translation.core";
import { useEffect, useState } from "react";
import { TagListFilter } from "../types/tag";
import { useForm, useWatch } from "react-hook-form";
import { getDontHandleError, post } from "../core/fetch.core";
import { UserPreference } from "../types/user";

export default function TagPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.tag.tag)} titleBtn={<AddLink id="tag-create" href="/tag/create" />}>
      <Main />
    </Layout>
  );
}

function Main() {
  const methods = useTagListFilterForm();

  if (!methods) return null;
  return (
    <>
      <ListSection>
        <TagListComp methods={methods} />
      </ListSection>
    </>
  );
}

function useTagListFilterForm() {
  const { query, isReady } = useRouter();
  const [isLoadingReady, setIsLoadingReady] = useState(false);

  const methods = useForm<TagListFilter>({
    defaultValues: {
      page: 1,
      pageSize: 20,
      sort: "name",
      sortAsec: 1,
    },
  });

  // sync the page param back to form hook
  useEffect(() => {
    methods.setValue("page", Number(query.page ?? 1));

    // eslint-disable-next-line
  }, [query, isReady]);

  // userPreference ready
  useEffect(() => {
    loadUserPreference().then(() => {
      // delay this a little bit for the useWatch to trigger first
      setTimeout(() => {
        setIsLoadingReady(true);
      }, 11);
    });

    // eslint-disable-next-line
  }, []);

  const watch = useWatch({ control: methods.control });

  // userPreference/add
  useEffect(() => {
    if (!isReady) return;
    if (!isLoadingReady) return;

    const preference = { ...watch };
    delete preference.page;
    delete preference.pageSize;

    post("/admin/userPreference/add", {
      type: "tagFilter",
      preference,
    });

    // eslint-disable-next-line
  }, [watch]);

  async function loadUserPreference() {
    const res = await getDontHandleError<UserPreference>("/admin/userPreference/get?type=tagFilter");

    if (res.status === 404) return;
    if (!res.data) return;

    const [page, pageSize] = methods.getValues(["page", "pageSize"]);

    methods.reset({ ...res.data.preference, page, pageSize });
  }

  if (!isReady) return null;
  if (!isLoadingReady) return null;

  return methods;
}
